import React from 'react';

import { withStyles, ButtonBase, Grid, Typography } from '@material-ui/core';
import AppData from '../../model/AppData';
import MSnackbar from '../view/MSnackbar';
import ToName from '../../control/ToName';



import {
    withRouter,
} from "react-router-dom"
import Live from '../../model/Live';
import AppUtils from '../../control/apputlis';

const ICON1 = require("../../images/icons/ren_icon.png");
const ICON2 = require("../../images/icons/guanfangtuijian.png");
const ICON3 = require("../../images/icons/huo_icon.png");


class PreviewDoubleItem extends React.Component {

    _onClickAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;

        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        let token = 0;

        if (AppData.me.token !== '') { 
            token = AppData.me.token
        }

        let customerId = 0
        if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
            customerId = AppData.me.customer_id
        } 
        let uid = AppUtils.getStorageItem('uid');
        let fastkey = AppUtils.getStorageItem("fastkey");
        let roomIp = AppUtils.getStorageItem("roomIp");
        let roomPort = AppUtils.getStorageItem("roomPort");
        let fid = AppData.me.free_id 

        console.log("fid=========>",fid);

        

        ToName(this.props, `/play/${room_id}/${match_type}/${match_id}/${uid}/${fastkey}/${roomIp}/${roomPort}/${os}/${token}/${customerId}/${fid}`,data)

    }

    formatNum = (num) => {
        if (num > 100000000) {
            return (num / 100000000).toFixed(0) + '亿'
        } else if (num > 10000) {
            if (num > 1000000) {
                return (num / 10000).toFixed(0) + '万'
            } else if (num > 100000) {
                return (num / 10000).toFixed(1) + '万'
            }
        }
        return num;
    }

    render() {
        let { classes, data, isRocomm, hot } = this.props;
        let live = new Live(data);
        var tips = '休息';
        if (live.living()) {
            tips = '直播中';
        }

        let room_cover = data.room_cover;
        if (data.screen_shots && data.screen_shots.length > 0) {
            room_cover = data.screen_shots;
        }
        let tag = data.tag;
        let tag1 = data.tag1;

        return (
            <Grid item container className={classes.root} style={this.props.style} direction='column'>
                <ButtonBase disableRipple className={classes.buttonBase}
                    style={{
                        // backgroundSize: 'cover',
                        // backgroundImage: `url(${room_cover})`,
                        // backgroundRepeat: 'no-repeat',
                        backgroundColor: '#e6e6e6'
                    }}
                    onClick={() => this._onClickAnchor(data)} >

                    <img src={room_cover} className={classes.image} />



                    {
                        isRocomm ? <Grid container direction='row' alignItems='center' className={classes.recommBg}>
                            <img src={ICON2} style={{ width: 76, height: 9 }}></img>
                        </Grid>
                            : null
                    }
                    {
                        <Grid container direction='row' alignItems='center' justifyContent='center' className={classes.hotView} >
                            <img src={ICON1} style={{ width: 5, height: 7, marginLeft: 4 }}></img>
                            <Typography style={{ color: '#FFF', marginLeft: 4, fontSize: 9 }}>{this.formatNum(data.heat)}</Typography>
                        </Grid>
                    }
                    {
                        data.nickName && data.nickName.length > 0 && <Grid container direction='row' alignItems='center' className={classes.scoreBg}>
                            <img src={data.portrait} style={{ width: 20, height: 20, marginLeft: 4, borderRadius: 10 }}></img>
                            <Typography style={{ color: '#FFF', marginLeft: 8, fontSize: 9 }} >{data.nickName}</Typography>
                        </Grid>
                    }
                </ButtonBase>
                <Grid container direction='row' alignItems='center'>
                    {/* {
                        hot && <img src={ICON3} style={{ width: 15, height: 15 }}></img>
                    } */}
                    <Typography align='left' noWrap style={{ flex: 1, color: '#0D0D0D', fontSize: 13, marginTop: 4, marginRight: 8 }} >{data.room_title}</Typography>
                </Grid>

                <div style={{ display: "flex", flexDirection: "row", marginTop: 5 }}>
                    {tag && tag != '' &&
                        <div className={classes.tag}>{tag}</div>
                    }
                    {tag1 && tag1 != '' &&
                        <div className={classes.tag}>{tag1}</div>
                    }
                </div>
                <MSnackbar ref='toast' />
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        marginTop: 0,
        padding: theme.spacing(0, 0, 1, 0),
    },

    tag: {
        backgroundColor: "#EAEAEA",
        color: "#919191",
        height: 20,
        lineHeight: '20px',
        fontSize: 10,
        marginRight: 6,
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 10,


    },

    image: {
        width: '50vw',
        height: '26vw',
        // object-fit: cover;
        objectFit: 'cover'
    },
    buttonBase: {
        width: '100%',
        height: '26vw',
        borderRadius: 10,
        overflow: 'hidden'

    },
    scoreBg: {
        display: 'flex',
        justifyContent: '',
        alignItems: 'center',
        padding: theme.spacing(0),
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: 26.5,
        background: 'linear-gradient(0deg, #00000099 0%, #00000000 100%)',
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10,
    },
    mosaicBg: {
        position: 'absolute',
        top: 8,
        left: 8,
        padding: theme.spacing(0.2, 0.6),
        backgroundColor: '#0000005F',
        borderRadius: 10,
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
        maxWidth: 54,
    },
    recommBg: {
        position: 'absolute',
        top: 4,
        left: 0,
        flexDirection: 'row',
        alignItems: 'center',
        flex: 1,
    },
    point: {
        width: 4,
        height: 4,
        backgroundColor: '#8CF63E',
        borderRadius: 2,
    },
    point1: {
        width: 4,
        height: 4,
        backgroundColor: '#F7F7F7',
        borderRadius: 2,
    },
    hotView: {
        backgroundColor: 'rgba(0,0,0,0.3)',
        height: 18,
        width: 52,
        borderRadius: 9,
        position: 'absolute',
        top: 4,
        right: 4,
        flex: 1,
    }
}))(PreviewDoubleItem));